import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé. Connectez-vous.");
      navigate("/login");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-8">
      <div className="w-full max-w-sm animate-fade-up">
        <h1 className="font-display text-3xl font-bold">Nouveau mot de passe</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Choisissez un nouveau mot de passe sécurisé.
        </p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input
            data-testid="reset-password"
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-border bg-transparent px-3 py-2.5 text-sm outline-none transition-colors focus:border-primary"
            placeholder="••••••••"
          />
          <div>
            <input
              data-testid="reset-confirm-password"
              type="password"
              required
              minLength={6}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full border border-border bg-transparent px-3 py-2.5 text-sm outline-none transition-colors focus:border-primary"
              placeholder="Confirmer le mot de passe"
            />
            {confirmPassword && password !== confirmPassword && (
              <p className="mt-1.5 text-xs text-red-500" data-testid="reset-password-mismatch">
                Les mots de passe ne correspondent pas
              </p>
            )}
          </div>
          <button
            type="submit"
            disabled={loading || !token}
            data-testid="reset-submit"
            className="flex w-full items-center justify-center gap-2 bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground transition-colors duration-200 hover:bg-primary/90 disabled:opacity-60"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            Réinitialiser
          </button>
        </form>
        <Link
          to="/login"
          className="mt-6 flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
          data-testid="back-to-login"
        >
          <ArrowLeft size={16} /> Retour à la connexion
        </Link>
      </div>
    </div>
  );
}
